// Import react elements
import { useState } from "react";

// Import api calls
import { 
    updateConnection,
} from "api/APIStrichCalls";

import CustomisableTable from 'global/components/CustomisableTable';
//import CustomisableTableSelectedRowsActionsDropwdown from 'global/components/CustomisableTableActionsDropdown';

// Import utilities
import { B2S } from "global/utilities/BooleanConverters";



// Format the columns for the pod designs table - Need to set these values in fetchPodDesigns mapped array
const initialTableColumns = [

    // Select tick box at left of table rows - if we want to multi select designs and action them
    //{ key: 'select', label: '', resizable: false, minWidth: 40, maxWidth: 40, draggable: false, textFilter: false },

    { key: 'view', label: '', resizable: false, minWidth: 55, maxWidth: 50, draggable: false, textFilter: false },
     
    { key: 'connectionname', label: 'Store Name', resizable: true, minWidth: 100, maxWidth: 300, draggable: true, textFilter: true },

    { key: 'conntype', label: 'Store Type', resizable: true, minWidth: 100, maxWidth: 200, draggable: true, textFilter: true },
   
    { key: 'storeUrl', label: 'Store Link', resizable: true, minWidth: 260, maxWidth: 700, draggable: true, textFilter: true, filterKey: 'storeUrlText', sortKey: 'storeUrlText' },

    { key: 'active', label: 'Active', resizable: false, minWidth: 60, maxWidth: 60, draggable: true, textFilter: false, th_classname: "", td_classname: "connections-table_active" },

];



const ConnectionsTable = ({ connectionsData, setConnectionsData, loadingConnections, handleSelectConnection, handleDeleteConnection, token }) => {

   //console.log("Connections Table data:", connectionsData)

    // Set filters state - needs passing to filters component and table component
    const [filters] = useState({});

    // Set state for selected table rows
    const [selectedConnectionRows, setSelectedConnectionRows] = useState([]);
    
    // Set state for selected table rows
    // eslint-disable-next-line no-unused-vars
    const [numberOfDisplayedConnections, setNumberOfDisplayedConnections] = useState(0);



    // Function to handle active toggle change
    const activeToggleChange = async (id, activeValue) => {

        // Create the payload for the call
        const payload = {
            active: B2S(activeValue),
            id: id,
        };

        // Make the call to update the connection
        const response = await updateConnection(token, payload);

        // Check if it was successful
        if (response.success) {

            // Update the local state
            setConnectionsData((prev) => {

                // Map through the connection
                return prev.map((con) => {

                    // Update only the matched connection
                    if (con.id === id) {

                        return {
                            ...con,
                            active: B2S(activeValue),              
                        };

                    }

                    // Keep all other connections unchanged
                    return con;

                });

            });

        }

    };



    // Create menu options array - used for dropdown per table row 
    const connectionActionsConfig = [
        {
            id: "view", // Unique id
            label: 'View Details', // Title label
            clickFunction: handleSelectConnection, // Click function used for table row button
            icon: '✏️', // Optional icon
            disabled: false, // Disabled state
            singleItemAction: true, // Is this action just for single item
        },
        {
            id: "delete",
            label: 'Delete',
            clickFunction: handleDeleteConnection,
            icon: '🗑️',
            disabled: false,
            color: 'red',
        },

    ];


    return (

        <div className="connections-table__full-width-scroll">

            <CustomisableTable
                tableData={connectionsData}
                initialTableColumns={initialTableColumns}
                filterKeys={[]}
                filters={filters}
                selectedRows={selectedConnectionRows}
                setSelectedRows={setSelectedConnectionRows}
                loadingData={loadingConnections}
                setNumberOfDisplayedDataRows={setNumberOfDisplayedConnections}
                menuOptions={connectionActionsConfig} 
                handleRowSingleClick={handleSelectConnection}
                // Active column toggle function (toggles active state of the row)
                activeTogglefunction={activeToggleChange} 
                noDataAvaiableMessage={"No stores to display."} 
            />

        </div>

    );

};

export default ConnectionsTable;